import React from 'react';
import cx from 'classnames';

import Link from 'app/components/common/Link';
import { TZKT_EXPLORER_URL } from 'app/utils/defaults';
import { useWindowSize } from 'app/utils/windowResize';
import { shortize } from 'app/utils/helpers';

import s from './TokenAddressInfo.module.sass';

type TokenAddressInfoProps = {
  className?: string
  address: string
  tokenId?: string | null
  loading?: boolean
};

const TokenAddressInfo: React.FC<TokenAddressInfoProps> = ({
  address,
  loading,
  className,
  tokenId,
}) => {
  const { width } = useWindowSize();

  const isMobileScreen = width <= 632;

  const isXtz = address === 'Tez';

  return (
    <div className={cx(s.root, className)}>
      <div className={cx(s.text)}>
        Token address:
      </div>

      <div className={cx(s.wrapper, s.interactive)}>
        {loading ? '...' : (
          <>
            {
            isXtz ? (
              <span className={cx(s.tezAddress)}>
                {address}
              </span>
            ) : (
              <>
                <a
                  href={`${TZKT_EXPLORER_URL}/${address}`}
                  target="_blank"
                  rel="noreferrer"
                  className={cx(s.address)}
                >
                  {isMobileScreen ? shortize(address, 10) : address}
                  {tokenId && ` (ID: ${tokenId})`}
                </a>

                <Link value={address} theme="plain" />
              </>
            )
          }
          </>
        )}
      </div>
    </div>
  );
};

export default TokenAddressInfo;
